import React, {useEffect, useState} from "react";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import {useForm} from "react-hook-form";
import TextInput from "../../Components/Inputs/TextInput";

export default function () {
  const { reset, handleSubmit, register} = useForm();
  const [errors, setErrors] = useState({});

  useEffect(() => {
    axios.get(  `contact-infos`).then(res => {
      if(res.data.status === 'success'){
        reset(res.data.contact_infos);
      }
    });
  }, []);

  const edit = data => {
    axios.put(`contact-infos`, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Contact Details has been updated successfully!', {
            icon: "success",
          });
          setErrors({})
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit Contact Details">
      <form className="form w-100 row" onSubmit={handleSubmit(edit)}>
        <TextInput
          label="Phone number"
          name="phone"
          parentClasses="col-md-6"
          register={register}
          errorMessage={errors?.phone}
        />

        <TextInput
          label="Email"
          name="email"
          parentClasses="col-md-6"
          register={register}
          errorMessage={errors?.email}
        />

        <TextInput
          label="Facebook url"
          name="facebook"
          parentClasses="col-md-6"
          register={register}
          errorMessage={errors?.facebook}
        />

        <TextInput
          label="Instagram url"
          name="instagram"
          parentClasses="col-md-6"
          register={register}
          errorMessage={errors?.instagram}
        />

        <TextInput
          label="Linkedin url"
          name="linkedin"
          parentClasses="col-md-6"
          register={register}
          errorMessage={errors?.linkedin}
        />

        <TextInput
          label="Youtube url"
          name="youtube"
          parentClasses="col-md-6"
          register={register}
          errorMessage={errors?.youtube}
        />

        <SubmitButton
          title="Save"
          classes="w-auto d-inline-block mt-4"
        />
      </form>
    </Card>
  );
}